export const SECTION_PATH_TO_ID: Record<string, string> = {
  '/features': 'features',
  '/pricing': 'pricing',
  '/compare': 'compare',
  '/solutions': 'solutions',
};
